import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import styled from "styled-components";
import DropdownSelect from "../../components/DropdownSelect";
import StoreController, {
  CurrentOrderType,
  MapStoreType,
  MapType,
} from "../../controller/StoreController";
import UserController, {
  AddressType,
  PositionContextType,
} from "../../controller/UserController";
import { orderDetailRealmType } from "../../recoil/cart";
import RecorderComponent from "../../components/Recorder";
import Recorder from "../../components/ccOS/Recorder";
import AsyncLocalStorage from "../../util/AsyncLocalStorage";
import Spinner from "../../components/ccOS/Spinner";

const storeTypeList = [
  { value: 0, name: "전체" },
  { value: 1, name: "카페" },
  { value: 2, name: "음식점" },
  { value: 8, name: "상점" },
];

const Home = () => {
  const navigate = useNavigate();

  const { position } = useOutletContext<PositionContextType>();
  const [isLoading, setIsLoading] = useState<boolean>(false); // 데이터 로딩

  const angle = 120;

  // 방위
  const [bearing, setBearing] = useState<string>("");
  // 검색어
  const [keyword, setKeyword] = useState<string>("");
  const [searchKeyword, setSearchKeyword] = useState<string>("");

  const [isGuide, setIsGuide] = useState<boolean>(true);
  const [isSearchMap, setIsSearchMap] = useState<boolean>(false);

  // 전체, 카페, 음식점
  const [searchType, setSearchType] = useState<number>(0);
  // api호출된 모든 매장
  const [allStoreList, setAllStoreList] = useState<MapType>();
  // 지도 매장
  const [mapStoreList, setMapStoreList] = useState<(MapStoreType | null)[]>([]);
  // 내 주변 추천매장
  const [recommendedList, setRecommendedList] = useState<MapStoreType[]>([]);
  // 최근 주문한 매장
  const [currentOrder, setCurrentOrder] = useState<CurrentOrderType[]>([]);
  // 검색결과 주소
  const [searchedAddress, setSearchedAddress] = useState<AddressType[]>([]);
  // 목적지
  const [destination, setDestination] = useState<AddressType | null>(null);

  // API 호출
  const getRightWrapData = async () => {
    try {
      const oParams = {
        user_lat: position.lat,
        user_lng: position.lng,
        radius: 2,
      };
      const oRes = await StoreController.getMainOrderNStores(oParams);
      if (oRes && oRes.data) {
        console.log("getMainOrderNStores", oRes.data);
        if (oRes && oRes.data) {
          setCurrentOrder(
            (Object.values(oRes.data.content) as any).find(
              (obj: any) => obj.type === "userorder"
            ).data
          );
          setRecommendedList(
            (Object.values(oRes.data.content) as any).find(
              (obj: any) => obj.type === "storeslist"
            ).data
          );
        }
      }
    } catch (err) {
      console.log("err---->", err);
    }
  };
  const getStoreList = async () => {
    try {
      const oParams = {
        latitude: position.lat,
        longitude: position.lng,
        limit: 200,
        angle: angle,
        filter: searchType,
      };
      const oRes = await StoreController.getMainList(oParams);

      if (oRes && oRes.data) {
        console.log("getMainList", oRes.data);
        if (oRes && oRes.data) {
          setDestination(null);
          setBearing(oRes.data.compass_point);
          setAllStoreList(oRes.data.stores);
          getMapList(oRes.data.stores);
          setDestination(null);
        }
      }
    } catch (err) {
      console.log("err---->", err);
    }
  };
  const searchDestination = async () => {
    try {
      if (searchKeyword === "") {
        stopSearch();
      } else {
        const oParams = {
          search_value: searchKeyword,
        };
        const oRes = await UserController.searchAddress(oParams);

        if (oRes && oRes.data) {
          console.log("searchAddress", oRes.data);
          if (oRes && oRes.data) {
            setSearchedAddress([...oRes.data.address]);
          }
        }
      }
    } catch (err) {
      console.log("err---->", err);
    }
  };
  const searchStoreList = async (item: AddressType) => {
    try {
      setIsLoading(true);
      const oParams = {
        destination: { lat: item.y, lng: item.x },
        user_location: position,
      };

      const oRes = await UserController.dtDistance(oParams);

      if (oRes && oRes.data) {
        console.log("dtDistance", oRes.data);
        if (oRes.data.stores) {
          getSearchedList(oRes.data.stores);
        }
        setIsLoading(false);
      }
    } catch (err) {
      console.log("err---->", err);
    }
  };

  const getMapList = (storeList: MapType) => {
    const filteredList = {
      left: storeList.left.filter((item: MapStoreType) => {
        if (searchType !== 0) {
          return (
            item.store_name.includes(keyword) &&
            item.parent_store_type_id === searchType
          );
        } else return item.store_name.includes(keyword);
      }),
      right: storeList.right.filter((item: MapStoreType) => {
        if (searchType !== 0) {
          return (
            item.store_name.includes(keyword) &&
            item.parent_store_type_id === searchType
          );
        } else return item.store_name.includes(keyword);
      }),
    };
    console.log("filter", filteredList);
    let mapList: (MapStoreType | null)[] = [];
    mapList = [...mapList, ...filteredList.left.slice(0, 8)];
    for (let i = 8; mapList.length < i; ) {
      mapList.push(null);
    }
    mapList = [...mapList, ...filteredList.right.slice(0, 8)];
    for (let i = 16; mapList.length < i; ) {
      mapList.push(null);
    }
    setMapStoreList([...mapList]);
  };

  const getSearchedList = (storeList: MapStoreType[]) => {
    const filteredList = storeList.filter((item: MapStoreType) => {
      if (searchType !== 0) {
        return item.store_name.includes(keyword);
        // &&
        // item.parent_store_type_id === searchType
      } else return item.store_name.includes(keyword);
    });
    console.log("filter", filteredList);
    setMapStoreList([...filteredList]);
  };

  const reorderHistory = (item: CurrentOrderType) => {
    const reorder_data: orderDetailRealmType[] = [];
    item.aPrdData.map((product) => {
      const reorderItem: orderDetailRealmType = {
        store_id: item.oStoreData.store_id,
        product_id: product.prd_id,
        product_name: product.prd_name,
        product_org_price: Number(product.prd_org_price),
        product_quantity: product.amount!,
        product_total_amount: Number(product.prd_base_price),
        options: product.oSelectedOptions
          ? Object.values(product.oSelectedOptions)
          : [],
      };
      reorder_data.push(reorderItem);
    });
    AsyncLocalStorage.setItem(
      "reorder",
      JSON.stringify({
        store_id: item.oStoreData.store_id,
        data: reorder_data,
      })
    );
    navigate("/order/payment");
  };

  const onSearch = (e: any) => {
    e.stopPropagation();
    setIsSearchMap(true);
  };
  const stopSearch = () => {
    getStoreList();
    setIsSearchMap(false);
  };
  const getDestination = (item: AddressType) => {
    console.log("set");
    setDestination(item);
    setIsSearchMap(false);
    setSearchKeyword("");
    setSearchedAddress([]);
    searchStoreList(item);
  };
  const closeGuideWrap = () => {
    setIsGuide(false);
    setIsSearchMap(false);
    setSearchKeyword("");
    setSearchedAddress([]);
  };
  const navigateMapStore = (item: MapStoreType | null) => {
    if (item !== null) {
      navigate("/order/main", {
        state: { store_id: item.store_id },
      });
    }
  };

  const onChangeKeyword = (e: any) => {
    setKeyword(e.target.value);
  };
  const onChangeSearchKeyword = (e: any) => {
    setSearchKeyword(e.target.value);
  };

  const onChange_searchType = (option: any) => {
    setSearchType(option.value);
  };

  useEffect(() => {
    AsyncLocalStorage.removeItem("reorder");
    setTimeout(() => {
      setIsGuide(false);
    }, 1500);
  }, []);

  useEffect(() => {
    if (position) {
      if (destination === null) getStoreList();
      getRightWrapData();
    }
  }, [position]);

  const RenderSpeechBubble = ({ content }: any) => {
    return (
      <div
        className={`speechBubbleWrap ${
          !isGuide && destination !== null && "search"
        }`}
      >
        <div className="bubble">
          <h3>{content}</h3>
          {!isGuide && destination !== null && (
            <button onClick={onSearch}>
              <h4>변경</h4>
            </button>
          )}
        </div>
      </div>
    );
  };
  const RenderCurrentList = useMemo(() => {
    return (
      <div className="storeListWrap">
        {currentOrder.map((data, index) => (
          <div className="storeListCard current" key={index}>
            <div className="titleWrap">
              <div className="row">
                <h2>{data.oStoreData.store_name}</h2>
                {data.oStoreData.favorites_flag === 1 ? (
                  <img
                    src={`${process.env.PUBLIC_URL}/svg/ic_heartColor.svg`}
                    alt="heart"
                  />
                ) : (
                  <img
                    src={`${process.env.PUBLIC_URL}/svg/ic_heart.svg`}
                    alt="heart"
                  />
                )}
              </div>
              <h3 className="distance">
                {data.oStoreData.distance.toFixed(1)}km
              </h3>
            </div>
            <div>
              <h3>{data.aPrdData[0].prd_name}</h3>
              <h3>
                {data.aPrdData.length > 1
                  ? `외 ${data.aPrdData.length - 1}개`
                  : ""}
              </h3>
            </div>
            <button onClick={() => reorderHistory(data)}>주문하기</button>
          </div>
        ))}
      </div>
    );
  }, [currentOrder]);
  const RenderStoreList = useMemo(() => {
    return (
      <div className="storeListWrap">
        {recommendedList.map((data, index) => (
          <div
            className="storeListCard"
            key={index}
            onClick={() =>
              navigate("/order/main", { state: { store_id: data.store_id } })
            }
          >
            <img
              className={`${
                (data.url_path === null || data.url_path === "") && "none"
              }`}
              src={
                data.url_path === null || data.url_path === ""
                  ? `${process.env.PUBLIC_URL}/svg/ic_stamp_none.svg`
                  : data.url_path
              }
              alt="매장이미지"
            />
            <div className="storeInfo">
              <div className="storeInfoTitle">
                <h1>{data.store_name}</h1>
                {data.favorites_flag === 1 ? (
                  <img
                    src={`${process.env.PUBLIC_URL}/svg/ic_heartColor.svg`}
                    alt="heart"
                  />
                ) : (
                  <img
                    src={`${process.env.PUBLIC_URL}/svg/ic_heart.svg`}
                    alt="heart"
                  />
                )}
              </div>
              <p>{data.distance.toFixed(1)}km</p>
            </div>
          </div>
        ))}
      </div>
    );
  }, [recommendedList]);
  const RenderStoreView = useMemo(() => {
    return (
      <div className="storeViewWrap">
        <div className="storeView">
          {mapStoreList.map((item: MapStoreType | null, index: number) => {
            return (
              ((destination === null && index < 8) ||
                (destination !== null && index % 4 < 2 && index < 14)) && (
                <div
                  key={index}
                  className={`storeItem ${item === null && "none"}`}
                  onClick={() => navigateMapStore(item)}
                >
                  {item !== null && (
                    <>
                      <div className="row">
                        {item.convert_bearing && (
                          <img
                            src={`${process.env.PUBLIC_URL}/svg/ic_${
                              item.convert_bearing > -30
                                ? "top"
                                : item.convert_bearing > -60
                                ? "top_left"
                                : "left"
                            }_arrow.svg`}
                            alt="화살표아이콘"
                          />
                        )}
                        <h3 className="distance">
                          {destination === null
                            ? `${item.distance.toFixed(1)}km`
                            : item.distance}
                        </h3>
                      </div>
                      <img
                        src={`${process.env.PUBLIC_URL}/svg/ic_${
                          item.parent_store_type_id === 1
                            ? "cafe"
                            : item.parent_store_type_id === 2
                            ? "restaurant"
                            : "shop"
                        }.svg`}
                        alt="store아이콘"
                        width="40%"
                        height="40%"
                      />
                      <h3>{item.store_name}</h3>
                    </>
                  )}
                </div>
              )
            );
          })}
        </div>
        <div className="storeView compose">
          {(destination !== null || isGuide) && (
            <RenderSpeechBubble
              content={
                destination !== null
                  ? destination.address_name
                  : "나침반을 클릭해서 목적지를 설정하면\n경로상에 있는 스루매장을 추천해드려요"
              }
            />
          )}
          <div className="composeIcon" onClick={onSearch}>
            <h2>{bearing}</h2>
            <img
              src={`${process.env.PUBLIC_URL}/svg/ic_compose.svg`}
              alt="나침반"
            />
          </div>
          <img
            src={`${process.env.PUBLIC_URL}/svg/ic_distance_bar.svg`}
            className="distanceBar"
            alt="거리 바"
          />
        </div>
        <div className="storeView">
          {mapStoreList.map((item: MapStoreType | null, index: number) => {
            return (
              ((destination === null && index > 7) ||
                (destination !== null && index % 4 > 1 && index < 16)) && (
                <div
                  key={index}
                  className={`storeItem ${item === null && "none"}`}
                  onClick={() => navigateMapStore(item)}
                >
                  {item !== null && (
                    <>
                      <div className="row">
                        {item.convert_bearing && (
                          <img
                            src={`${process.env.PUBLIC_URL}/svg/ic_${
                              item.convert_bearing < 30
                                ? "top"
                                : item.convert_bearing < 60
                                ? "top_right"
                                : "right"
                            }_arrow.svg`}
                            alt="화살표아이콘"
                          />
                        )}
                        <h3 className="distance">
                          {destination === null
                            ? `${item.distance.toFixed(1)}km`
                            : item.distance}
                        </h3>
                      </div>
                      <img
                        src={`${process.env.PUBLIC_URL}/svg/ic_${
                          item.parent_store_type_id === 1
                            ? "cafe"
                            : item.parent_store_type_id === 2
                            ? "restaurant"
                            : "shop"
                        }.svg`}
                        alt="store아이콘"
                        width="40%"
                        height="40%"
                      />
                      <h3>{item.store_name}</h3>
                    </>
                  )}
                </div>
              )
            );
          })}
        </div>
      </div>
    );
  }, [mapStoreList, isGuide, destination]);

  return (
    <>
      <Style>
        <div className="wrapper" onClick={closeGuideWrap}>
          <div className="leftWrap">
            {(isGuide || isSearchMap) && <div className="guideWrap" />}
            {isSearchMap && (
              <div className="searchWrap" onClick={(e) => e.stopPropagation()}>
                <div className="inputWrap">
                  <input
                    type="text"
                    value={searchKeyword}
                    placeholder="목적지까지 스루매장을 추천합니다"
                    onChange={onChangeSearchKeyword}
                  />
                  {searchedAddress.length > 0 && (
                    <div className="listWrap">
                      {searchedAddress.map((item, index) => {
                        return (
                          <h3 onClick={() => getDestination(item)} key={index}>
                            {item.address_name}
                          </h3>
                        );
                      })}
                    </div>
                  )}
                </div>
                <button onClick={searchDestination}>
                  <img
                    src={`${process.env.PUBLIC_URL}/svg/ic_glasses.svg`}
                    alt="돋보기아이콘"
                  />
                </button>
              </div>
            )}
            <div className="header">
              <div className="selectWrap">
                <DropdownSelect
                  options={storeTypeList}
                  defaultValue={searchType}
                  onChangeValue={onChange_searchType}
                />
              </div>
              <input
                type="text"
                value={keyword}
                placeholder="매장명을 검색해주세요"
                onChange={onChangeKeyword}
              />
              <button
                onClick={() =>
                  destination === null
                    ? getStoreList()
                    : searchStoreList(destination)
                }
              >
                <img
                  src={`${process.env.PUBLIC_URL}/svg/ic_glasses.svg`}
                  alt="돋보기아이콘"
                />
              </button>
            </div>
            <div className="content">{RenderStoreView}</div>
          </div>
          <div className="sideLine" />
          <div className="rightWrap">
            <div className="header">
              <button
                className="flexCenter"
                onClick={() => navigate("/order/favorite")}
              >
                <img
                  src={`${process.env.PUBLIC_URL}/svg/ic_heart_white.svg`}
                  width={32}
                  height={32}
                  alt="heart"
                />
                즐겨찾기
              </button>
              <button
                className="flexCenter"
                onClick={() => navigate("/order/history")}
              >
                <img
                  src={`${process.env.PUBLIC_URL}/svg/ic_list.svg`}
                  alt="주문내역 아이콘"
                  width={32}
                  height={32}
                />
                주문내역
              </button>
              <button className="setting" onClick={() => navigate("/setting")}>
                <img
                  src={`${process.env.PUBLIC_URL}/svg/ic_setting.svg`}
                  alt="환경설정 아이콘"
                  width={36}
                  height={36}
                />
              </button>
            </div>
            <div className="content">
              <div className="storeList">
                <h1>최근 주문한 매장</h1>
                {RenderCurrentList}
              </div>
              <div className="storeList">
                <h1>내 주변 추천매장</h1>
                {RenderStoreList}
              </div>
            </div>
            <button className="voice" onClick={() => navigate("/chat")}>
              <img
                src={`${process.env.PUBLIC_URL}/svg/ic_voice.svg`}
                alt="음성인식 아이콘"
                width="100%"
                height="100%"
              />
            </button>
          </div>
          {/* {isChat ? (
          ) : (
            <button className="voice" onClick={() => setIsChat(true)}>
              <img
                src={`${process.env.PUBLIC_URL}/svg/ic_voice.svg`}
                alt="음성인식 아이콘"
                width="100%"
                height="100%"
              />
            </button>
          )} */}
        </div>
        {isLoading && <Spinner />}
      </Style>
      {/* {isChat && <VoiceChat setIsChat={setIsChat} />} */}
    </>
  );
};

export default Home;

const Style = styled.div`
  /* 공통 */
  .wrapper {
    width: 100vw;
    height: 100vh;
    padding: 0;
    display: flex;
    overflow: hidden;
    gap: 1vh;
  }

  .leftWrap,
  .rightWrap {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    padding: 5vh;
    position: relative;
  }
  .sideLine {
    margin: 2% 0;
    min-width: 5px;
    width: 5px;
    border-radius: 10px;
    background: #272727;
  }

  button {
    height: 100%;
    border-radius: 10px;
    font-size: 24px;
    font-weight: 400;
    background: linear-gradient(180deg, #6490e8 0%, #001e62 100%);
  }
  h1 {
    font-size: 24px;
    font-weight: 600;
    color: #001e62;
  }

  input {
    width: 100%;
    height: 100%;
    max-height: 10vh;
    padding: 0 30px;
    border: 1px solid #737373;
    border-radius: 5px;
    font-size: 3vh;
    font-weight: 500;
    color: #fff;
    background: #000000;
  }
  input::placeholder {
    color: #cecece;
    opacity: 1;
  }
  input::-ms-input-placeholder {
    color: #cecece;
    opacity: 1;
  }

  /* header */
  .header {
    width: 100%;
    min-height: 10vh;
    height: 10vh;
    margin-bottom: 4vh;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;

    .selectWrap {
      width: 100%;
      height: 100%;
      max-width: 20%;
    }
  }

  /* content */
  .content {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;

    h1 {
      font-size: 3vh;
      margin-bottom: 1vh;
      color: #ffffff;
    }
  }

  .leftWrap {
    button {
      display: flex;
      align-items: center;
      padding: 0 40px;
      img {
        width: 42px;
        height: 42px;
      }
    }
  }
  .rightWrap {
    min-width: calc(100vw - 106vh);
    max-width: calc(100vw - 106vh);
    padding-right: 0;
    justify-content: space-between;
    .header {
      padding-right: 5vh;
    }
    button {
      flex: 1;
      white-space: nowrap;
      font-size: 3.5vh;
      background: linear-gradient(
        360deg,
        #001e62 0%,
        #6490e8 100%,
        #5e89e0 100%
      );
      img {
        width: 4.5vh;
        height: 4.5vh;
        margin-right: 20px;
      }
    }
    button.setting {
      flex: 0;
      display: flex;
      align-items: center;
      width: auto;
      height: 100%;
      padding: 0 4vh;
      img {
        margin: 0;
      }
    }
    .content {
      height: 86vh;
    }
  }

  .storeViewWrap {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    .storeView {
      width: 36vh;
      height: min-content;
      display: flex;
      align-items: flex-end;
      justify-content: flex-start;
      flex-wrap: wrap-reverse;
    }
    .storeItem {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      width: 50%;
      aspect-ratio: 1/1;
      border-radius: 10px;
      border: 1px solid #737373;
      padding: 12px;
      .row {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-around;
      }

      h3 {
        width: 100%;
        font-size: 2.5vh;
        font-weight: 400;
        text-align: center;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      h3.distance {
        width: auto;
        color: #a7a7a7;
      }
    }
    .storeItem.none {
      border: none;
    }
    .storeView.compose {
      width: 22vh;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-end;
      gap: 1%;
      .composeIcon {
        position: relative;
        text-align: center;
        h2 {
          position: relative;
          margin-bottom: -20px;
          font-size: 3.5vh;
          color: #ff5959;
          z-index: 2;
        }
      }
      img {
        height: 8vh;
        z-index: 1;
      }
      img.distanceBar {
        height: 60vh;
      }
    }
  }

  .storeList {
    width: 100%;
  }
  /* storeListWrap */
  .storeListWrap {
    flex: 1;
    display: flex;
    gap: 15px;
    overflow-y: hidden;
    overflow-x: auto;

    .storeListCard {
      position: relative;
      background: #000000;
      border: 1px solid #737373;
      box-shadow: 4px 4px 4px 0px #0000001a;
      border-radius: 10px;
      min-width: 31vh;
      max-width: 31vh;
      aspect-ratio: 1/1;

      img {
        width: 100%;
        height: 65%;
        border-radius: 10px 10px 0 0;
      }
      img.none {
        padding: 20px;
      }
      .storeInfo {
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 35%;
        padding: 1vh 2vh;
        display: flex;
        flex-direction: column;
        justify-content: center;
        background: #242424;
        border-bottom-right-radius: 10px;
        border-bottom-left-radius: 10px;
      }
      p {
        margin-top: 2px;
        font-size: 2vh;
        font-weight: 400;
        color: #a7a7a7;
      }

      .storeInfoTitle {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;

        h1 {
          margin: 0;
          font-size: 2.5vh;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        img {
          width: 28px;
          height: 28px;
          margin: 0;
        }
        button {
          width: min-content;
          padding: 0;
          padding-left: 10px;
          background: none;
        }
      }
    }
    .storeListCard.current {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      background: #242424;
      border: 1px solid #242424;
      padding: 3vh 2vh;

      .titleWrap {
        padding-bottom: 4%;
        .row {
          display: flex;
          align-items: center;
          justify-content: space-between;
          img {
            width: auto;
            height: auto;
          }
        }
      }
      h2 {
        font-size: 3.5vh;
        font-weight: 500;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      h3 {
        font-size: 2.5vh;
        font-weight: 500;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      h3.distance {
        font-weight: 400;
        color: #a7a7a7;
      }
      button {
        flex: none;
        height: 8vh;
        border-radius: 10px;
        background: #3d4779;
        font-size: 3vh;
        font-weight: 600;
        color: #ffffff;
        padding: 12px 0;
      }
    }
  }

  .speechBubbleWrap {
    position: absolute;
    top: 12vh;
    left: 50%;
    transform: translateX(-50%);
    z-index: 6;
    .bubble {
      max-width: 40vw;
      display: flex;
      align-items: center;
      padding: 1.5vh 6vh;
      border-radius: 50px;
      background: #efefef;
      white-space: pre-line;
      gap: 10px;
      h3 {
        font-size: 2.5vh;
        line-height: 3vh;
        font-weight: 600;
        color: #6490e8;
      }
    }
    .bubble:after {
      content: "";
      position: absolute;
      left: 50%;
      top: 90%;
      transform: translateX(-50%);
      width: 0;
      height: 0;
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
      border-top: 20px solid #efefef;
    }
  }
  .speechBubbleWrap.search {
    top: 15vh;
    .bubble {
      padding: 1vh 20px 1vh 30px;
      background: #ffffff;
    }
    .bubble:after {
      border-top: 20px solid #ffffff;
    }
    button {
      height: min-content;
      padding: 4px 16px;
      border-radius: 50px;
      background: #6490e8;
      h4 {
        white-space: nowrap;
        font-size: 2.5vh;
        line-height: 3vh;
        font-weight: 500;
      }
    }
  }

  .guideWrap {
    position: absolute;
    width: 100%;
    height: calc(100% - 20px);
    background: #000000b2;
    z-index: 5;
  }

  .searchWrap {
    position: absolute;
    margin-top: 9%;
    padding: 0 80px;
    width: 100%;
    max-width: 100%;
    display: flex;
    gap: 12px;
    z-index: 7;
    .inputWrap {
      width: 100%;
      input {
        background: #ffffff;
        color: #000000;
        border-radius: 10px;
        position: relative;
        z-index: 7;
      }
      .listWrap {
        width: 100%;
        max-height: 30vh;
        background: #eaeaea;
        border: 1px solid #6490e8;
        border-radius: 0 0 10px 10px;
        margin-top: -10px;
        padding: 20px 30px;
        overflow-y: auto;
        h3 {
          max-width: 490px;
          font-size: 3vh;
          line-height: 6vh;
          font-weight: 500;
          color: #979797;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
      }
    }

    button {
      height: 10vh;
      padding: 0 4vh;
    }
  }

  button.voice {
    height: 14%;
    left: -1vh;
    display: flex;
    align-items: center;
    justify-content: center;
    aspect-ratio: 1/1;
    border-radius: 100%;
    position: absolute;
    transform: translateX(-50%);
    bottom: 2.5vh;
    background: linear-gradient(180deg, #fb69ef 0%, #2a5ec4 86%);
    z-index: 100;

    img {
      width: 50%;
      height: 50%;
      margin: 0;
    }
  }
`;
